import {
  GlobalErrorHandler,
  ErrorBoundary as RaveErrorBoundary,
} from "@magalu/rave/errorBoundary";
import { useRouter } from "@magalu/rave/router";
import { usePlatformHooks } from "@magalu/ravejs-platform-hooks";
import { PropsWithChildren } from "react";

export const ErrorBoundary = ({ children }: PropsWithChildren) => {
  const { useErrorScreen } = usePlatformHooks();
  const router = useRouter();

  const handleGlobalError = (
    error,
    _source: "uncaught" | "unhandled-rejection"
  ) => {
    const isMiddlewareError =
      error.isRaveError && error.name === "MiddlewareError";
    if (!isMiddlewareError) return;

    useErrorScreen({
      fallback: () => {
        router.replace("/500/");
      },
    });
  };

  const handleRedirectErrorBoundary = () => {
    useErrorScreen({
      data: {
        errorCode: 999,
      },
      fallback: () => {
        router.replace("/500/");
      },
    });
    return null;
  };

  return (
    <RaveErrorBoundary onRenderWithError={handleRedirectErrorBoundary}>
      <GlobalErrorHandler onError={handleGlobalError} />
      {children}
    </RaveErrorBoundary>
  );
};
